import { render } from "./GoalManagement.vue?vue&type=template&id=5118b5fd&scoped=true&ts=true"
import script from "./GoalManagement.vue?vue&type=script&lang=ts"
export * from "./GoalManagement.vue?vue&type=script&lang=ts"

import "./GoalManagement.vue?vue&type=style&index=0&id=5118b5fd&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5118b5fd"]])

export default __exports__